import '../SectionMainBanner/section-main-banner.css';
import ScrollToTop from '../../@common.blocks/ScrollToTop/index';
import Text from '../../@common.blocks/Text/index';
import Container from '../../@common.blocks/Container';
import Button from '../../@common.blocks/Button';
import { HashLink } from 'react-router-hash-link';

const SectionMainBanner = () => {
  return (
    <div className="section-main-banner">
      <ScrollToTop />
      <Container>
        <Text component="p" size="bg">
          Наша компания производит широкий спектр работ для автоматизации
          производств, предприятий любого направления и сложности. Также мы
          производим программирование ПЛК и наладку работы оборудования в
          соответствии с требованиями заказчика. Сервисное обслуживание
          поставляемого ПО с оборудованием производится весь гарантийный срок.
        </Text>
      </Container>
      <div className="section-main-banner_btn">
        <Button color="green">
          <HashLink to="/fill_the_form">
            <div>Написать нам</div>
          </HashLink>
        </Button>
      </div>
    </div>
  );
};
export default SectionMainBanner;
